import { render, staticRenderFns } from "./ListarTodosparos.vue?vue&type=template&id=1e08a4a6&"
import script from "./ListarTodosparos.vue?vue&type=script&lang=js&"
export * from "./ListarTodosparos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports